import React from "react";
import Signup from "../components/Registration/Registration";
import { Container } from "react-bootstrap";
import { AuthProvider } from "../contexts/AuthContext";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Dashboard from "../components/Dashboard/Dashboard";
import Login from "../components/Login/Login";
import PrivateRoute from "./PrivateRoute";
import ForgotPassword from "../components/ForgetPassword/ForgetPassword";
import UpdateProfile from "./UpdateProfile";

function App() {
  return (
    <div
     style={{ minHeight: "100vh", backgroundColor: '#4d4d4c' }}
    >
    <Router>
      <AuthProvider>
        <Switch>
          <PrivateRoute exact path="/" component={Dashboard} />
          <PrivateRoute path="/update-profile" component={UpdateProfile} />
          <Route path="/signup" component={Signup} />
          <Route path="/login" component={Login} />
          <Route path="/forgot-password" component={ForgotPassword} />
        </Switch>
      </AuthProvider>
    </Router>
    </div>
  );
}

export default App;
